import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

// Store
import { Dispatch, RootState } from '../../../store/store';
import MainPdfImage from './mainPdfImage';
import { useTranslation } from 'react-i18next';
import { ReportScreenshot } from '../../../store/models/reports';
import { Cycle } from '../../CycleTable/types';
import ReportsImagesV2 from './reportsImagesV2';

interface IPdfImagesV2Props {
  cycleReportId?: string;
  cycle: Cycle,
  reports: ReportScreenshot[];
  pdfReports: ReportScreenshot[];
  loading: boolean;
  mainScreenshot: string;
  getReports: (cycleId: string) => Promise<void>;
  getReportPages: (cycleReportId: string) => Promise<void>;
  uploadAndSplitPdf: (params: { file: File; cycleId: string }) => Promise<void>;
  updateReportPositions: (reports: ReportScreenshot[]) => Promise<void>;
  updateReportInclude: (params: { reportId: string; isIncluded: boolean }) => Promise<void>;
}

const PdfImagesV2: FC<IPdfImagesV2Props> = ({
  cycleReportId: cycleReportIdProp,
  cycle,
  loading,
  reports,
  pdfReports,
  mainScreenshot,
  getReportPages,
  uploadAndSplitPdf,
  updateReportPositions,
  updateReportInclude,
}) => {
  const { cycleReportId: cycleReportIdParam } = useParams<{ cycleReportId: string }>();
  const cycleReportId = cycleReportIdProp ?? cycleReportIdParam;
  const [cycleName, setCycleName] = useState<string>('');
  const { t } = useTranslation();

  useEffect(() => {
    if (cycleReportId) {
      getReportPages(cycleReportId);
    }
  }, [cycleReportId]);

  useEffect(() => {    
    setCycleName(cycle?.name || '');
  }, [cycle]);

  const zommedReporTitle = `${t('labels.screenshotsFor')} ${cycleName}`
  const uploadedReporTitle = `${t('labels.uploadedScreenshots')} ${cycleName}`

  return (
    <div className="flex flex-col gap-3">
      <MainPdfImage loading={loading} mainScreenshot={mainScreenshot} />
      <ReportsImagesV2
        title={zommedReporTitle}
        loading={loading}
        reports={reports}
        updateReportPositions={updateReportPositions}
        updateReportInclude={updateReportInclude}
      />

      <ReportsImagesV2
        title={uploadedReporTitle}
        loading={loading}
        reports={pdfReports}
        updateReportPositions={updateReportPositions}
        updateReportInclude={updateReportInclude}
        uploadAndSplitPdf={uploadAndSplitPdf}
      />
    </div>
  );
};

const mapState = (state: RootState) => ({
  cycle: state.cycles.cycle,
  reports: state.reports.reports,
  pdfReports: state.reports.pdfReports,
  mainScreenshot: state.reports.mainScreenshot,
  loading: state.reports.loading,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getReportPages: dispatch.reports.fetchReportPages,
  uploadAndSplitPdf: dispatch.reports.uploadAndSplitPdf,
  takeGraphScreenshot: dispatch.reports.takeGraphScreenshot,
  updateReportPositions: dispatch.reports.updateReportPositionsV2,
  updateReportInclude: dispatch.reports.updateReportIncludeV2,
});

export default connect(mapState, mapDispatch)(PdfImagesV2);
